import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { Button, Dialog, DialogTitle, styled } from "@mui/material";
import { useTranslate } from "../../hooks/useTranslate";
import { doStartOver } from "./doStartOver";
import { PatientColorMap } from "../../layout/patientColorMap";
import { usePatientRouteChanger } from "../../PatientRoutes/routeChanger";
import { PatientRoute } from "../../PatientRoutes/PatientRoute";

//region [[ Styles ]]

const StartoverAreYouSureDialogView = styled(Dialog)({});

const DialogButtons = styled("div")({
  display: "flex",
  flexFlow: "row-reverse",
  margin: "15px",
  "& > *": {
    margin: "0 15px",
  },
});

const ButtonNo = styled(Button)({
  "& .patient-MuiButton-containedPrimary": {
    color: PatientColorMap.White,
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface StartoverAreYouSureDialogProps {
  open: boolean;
  onClose: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const StartoverAreYouSureDialog = ({
  open,
  onClose,
  ...props
}: StartoverAreYouSureDialogProps) => {
  const { translate } = useTranslate();

  const [isDialogOpen, setIsDialogOpen] = useState(!!open);
  const navigateTo = usePatientRouteChanger();

  useEffect(() => {
    setIsDialogOpen(open);
  }, [open]);

  const closeDialog = useCallback(() => {
    setIsDialogOpen(false);
    onClose?.();
  }, [setIsDialogOpen, onClose]);

  return (
    <StartoverAreYouSureDialogView open={isDialogOpen} onClose={closeDialog}>
      <DialogTitle>{translate("ARE_YOU_SURE_START_OVER")}</DialogTitle>
      <DialogButtons>
        <Button
          onClick={(e) => {
            navigateTo(PatientRoute.Questions);
            doStartOver(e);
          }}
        >
          {translate("ANSWER_YES")}
        </Button>
        <ButtonNo onClick={closeDialog} variant="contained" color={"primary"}>
          {translate("ANSWER_NO")}
        </ButtonNo>
      </DialogButtons>
    </StartoverAreYouSureDialogView>
  );
};
